import { render, staticRenderFns } from "./Exception03.vue?vue&type=template&id=be9d1ef2&scoped=true&"
import script from "./Exception03.vue?vue&type=script&lang=js&"
export * from "./Exception03.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9d1ef2",
  null
  
)

export default component.exports